// authorization API ---------------------------------------------------------

export const SIGNUP_URL = "/auth/register";

export const VERIFY_OTP_URL = "/auth/verifyOtp";

export const RESEND_OTP_URL = "/auth/resendOtp";

export const LOGIN_URL = "/auth/login";

export const FORGOT_PASSWORD_URL = "/auth/forgotPassword";

export const RESET_PASSWORD_URL = "/auth/reset-password";

export const LOGOUT_URL = "/auth/logout";

// user API ------------------------------------------------------------------

// dashboard

export const GET_DASHBOARD_IMAGES_URL = "/dashboard/cms";

export const GET_MARKET_HIGHLIGHTS_URL = "/dashboard/marketHighlights";

export const CLOSE_ACCOUNT_URL = "/profile/close-account";

export const CHANGE_PASSWORD_URL = "/profile/changePassword";

export const GET_VERIFICATION_URL = "/profile/verifications";

export const UPDATE_KYC_URL = "/profile/updateKycFlag";

export const GET_SETTINGS_URL = "/profile/getSettings";

export const SAVE_SETTINGS_URL = "profile/saveSettings";

export const VERIFY_EMAIL_URL = "/profile/emailOtpToVerify";

export const GET_DASHBOARD_TOTALS_URL = "/dashboard/dashboardTotals";

export const GET_TRANSACTION_HISTORY_URL = "/transaction/history?";

export const GET_ONRAMP_TRANSACTIONS_URL = "/transaction/onramp-transactions?";

export const GET_LOAN_HISTORY_URL = "/loan/history?";

export const GET_ASSETS_URL = "/profile/myAssetsBalance";

export const SAVE_INQUIRY_ID_URL = "/profile/saveInquiryId";

export const WITHDRAW_URL = "/transaction/withdraw";

export const GET_FIXED_TERM_URL = "/wallet/fixed-terms?";

export const CREATE_FIXED_TERM_URL = "/wallet/create-term";

export const TRANSACTION_VERIFICATION_URL = "/auth/verify-transaction";

export const BORROW_LOAN_URL = "/loan/borrow-loan";

export const PAY_LOAN_URL = "/loan/pay-loan";

export const CANCEL_FIXED_TERM_URL = "/wallet/cancel-term";

export const AUTORENEWAL_FIXED_TERMS_URL = "/wallet/edit-term";

export const COMPARE_COIN_URL = "/transaction/coin-compair";

export const PLATFORM_VARIABLE_URL = "/platForm/variable-name?";

export const SUBSCRIBE_URL = "/profile/subscribe";

// transaction Swap

export const SWAP_COIN_BALANCE_URL = "/transaction/swap";

// Affiliate Dashboard

export const AFFILIATE_DASHBOARD_COUNT = "/affiliate/dashboard-count";
export const AFFILIATE_DASHBOARD_LIST = "/affiliate/user-list";
export const AFFILIATE_DASHBOARD_Statics = "/affiliate/statistics";

export const AGENT_SIGN_UP = "/affiliate/register";

export const GET_PROFILE_URL = "/profile/me";
export const UPDATE_PROFILE = "/profile/update";
export const REMOVE_PROFILE_IMAGE = "/profile/remove-profile-image";
